import React from 'react';
var BookmarkSVG = function BookmarkSVG(_ref) {
    var height = _ref.height, className = _ref.className;
    return /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        height: height,
        className: className
    }, /*#__PURE__*/ React.createElement("polygon", {
        points: "25,30 16,25 7,30 7,1 25,1"
    }));
};
export default BookmarkSVG;
